import type { Translations } from './translation';

const translations: Translations = {
	ticket: 'Billet',
	ticketOptions: 'Options de billet',
	includedInTicket: 'Inclus dans le billet',
	journeyDetails: 'Détails du voyage',
	refreshItinerary: 'Actualiser le voyage',
	walk: 'à pied',
	bike: 'Vélo',
	cargoBike: 'Vélo Cargo',
	scooterStanding: 'Trottinette',
	scooterSeated: 'Trottinette avec siège',
	car: 'Voiture',
	taxi: 'Taxi',
	moped: 'Mobylette',
	unknownVehicleType: 'Type de véhicule inconnu',
	electricAssist: 'Assistance moteur électrique',
	electric: 'Électrique',
	combustion: 'Combustion',
	combustionDiesel: 'Diesel',
	hybrid: 'Hybride',
	plugInHybrid: 'Hybride rechargeable',
	hydrogenFuelCell: 'Pile à combustible hydrogène',
	from: 'De',
	to: 'À',
	viaStop: 'Arrêt intermédiaire',
	viaStops: 'Arrêts intermédiaires',
	addViaStop: 'Ajouter un arrêt intermédiaire',
	removeViaStop: "Supprimer l'arrêt intermédiaire",
	viaStayDuration: "Durée minimale d'arrêt",
	position: 'Position',
	arrival: 'Arrivée',
	departure: 'Départ',
	duration: 'Durée',
	arrivals: 'Arrivées',
	later: 'plus tard',
	earlier: 'plus tôt',
	departures: 'Départs',
	connections: 'Itinéraires',
	switchToArrivals: 'Afficher les arrivées',
	switchToDepartures: 'Afficher les départs',
	track: 'Voie',
	platform: 'Quai',
	trackAbr: 'V.',
	platformAbr: 'Q.',
	arrivalOnTrack: 'Arrivée sur la voie',
	tripIntermediateStops: (n: number) => {
		switch (n) {
			case 0:
				return 'Aucun arrêt intermédiaire';
			case 1:
				return '1 arrêt intermédiaire';
			default:
				return `${n} arrêts intermédiaires`;
		}
	},
	sharingProvider: 'Fournisseur',
	sharingProviders: 'Fournisseurs',
	none: 'Aucun',
	transfers: 'correspondances',
	returnOnlyAtStations: 'Le véhicule doit être retourné à une station.',
	roundtripStationReturnConstraint: 'Le véhicule doit être retourné à la station de départ.',
	rentalStation: 'Station',
	rentalGeofencingZone: 'Zone',
	noItinerariesFound: 'Aucun itinéraire trouvé.',
	advancedSearchOptions: 'Options',
	selectTransitModes: 'Sélectionner les modes de transport en commun',
	defaultSelectedModes: 'Tous les transports en commun',
	defaultSelectedProviders: 'Tous les fournisseurs',
	selectElevationCosts: 'Évitez les pentes abruptes.', // TODO Online translated
	wheelchair: 'Correspondances accessibles uniquement',
	useRoutedTransfers: 'Utiliser les correspondances routées',
	bikeRental: 'Utiliser véhicules partagés',
	requireBikeTransport: 'Transport vélo',
	requireCarTransport: 'Transport voiture',
	considerRentalReturnConstraints: 'Retourner les véhicules partagés pendant le voyage',
	default: 'Faire défaut',
	timetableSources: 'Sources des horaires',
	tripCancelled: 'Voyage annulé',
	stopCancelled: 'Arrêt supprimé',
	addStop: 'Ajouter un arrêt',
	inOutDisallowed: 'Impossible de monter/descendre',
	inDisallowed: 'Impossible de monter',
	outDisallowed: 'Impossible de descendre',
	unscheduledTrip: 'Voyage supplémentaire',
	alertsAvailable: 'Annonces disponibles',
	dataExpiredSince: 'Attention : Données expirées, valides jusqu’au',
	FLEX: 'Transport à la demande',
	WALK: 'À pied',
	BIKE: 'Vélo',
	RENTAL: 'Loué',
	RIDE_SHARING: 'Covoiturage',
	CAR: 'Voiture',
	CAR_PARKING: 'Garage voiture',
	CAR_DROPOFF: 'Dépose (voiture)',
	TRANSIT: 'Transports en commun',
	TRAM: 'Tram',
	SUBWAY: 'Métro',
	FERRY: 'Ferry',
	AIRPLANE: 'Avion',
	SUBURBAN: 'RER',
	BUS: 'Bus',
	COACH: 'Autocar',
	RAIL: 'Train',
	HIGHSPEED_RAIL: 'Train à grande vitesse',
	LONG_DISTANCE: 'Train intercité',
	NIGHT_RAIL: 'Train de nuit',
	REGIONAL_FAST_RAIL: 'Train express',
	ODM: 'Transport à la demande',
	REGIONAL_RAIL: 'Train régional',
	OTHER: 'Autres',
	routingSegments: {
		maxTransfers: 'Max. de correspondances',
		maxTravelTime: 'Temps de trajet max.',
		firstMile: 'Premier kilomètre',
		lastMile: 'Dernier kilomètre',
		direct: 'Connexion directe',
		maxPreTransitTime: 'Durée max. avant transit',
		maxPostTransitTime: 'Durée max. après transit',
		maxDirectTime: 'Durée max. directe',
		additionalTransferTime: 'Durée de correspondance supplémentaire',
		pedestrianSpeed: 'Vitesse piéton',
		cyclingSpeed: 'Vitesse vélo',
		transferTimeFactor: 'Facteur de durée de transfert'
	},
	elevationCosts: {
		NONE: 'Pas de détours',
		LOW: 'Petits détours',
		HIGH: 'Grands détours'
	},
	isochrones: {
		title: 'Isochrones',
		displayLevel: 'Couche de présentation',
		maxComputeLevel: 'Niveau de calcul max.',
		canvasRects: 'Rectes (Superposer)',
		canvasCircles: 'Cercles (Superposer)',
		geojsonCircles: 'Circles (Géométrie)',
		styling: 'Style pour Isochrone',
		noData: 'Pas de données',
		requestFailed: 'Échec de la demande'
	},
	alerts: {
		validFrom: 'Valable du',
		until: 'au',
		information: 'Informations',
		more: 'de plus'
	},
	RENTAL_BICYCLE: 'Vélo partagé',
	RENTAL_CARGO_BICYCLE: 'Vélo cargo partagé',
	RENTAL_CAR: 'Voiture partagée',
	RENTAL_MOPED: 'Mobylette partagée',
	RENTAL_SCOOTER_STANDING: 'Trottinette debout partagée',
	RENTAL_SCOOTER_SEATED: 'Trottinette assise partagée',
	RENTAL_OTHER: 'Autre véhicule partagé',
	incline: 'Pente',
	CABLE_CAR: 'Téléphérique',
	FUNICULAR: 'Funiculaire',
	AERIAL_LIFT: 'Remontée mécanique',
	toll: 'Attention ! Route à péage.',
	accessRestriction: 'Accès restreint',
	continuesAs: 'Continue comme',
	earlierAlternatives: 'Alternatives plus tôt',
	laterAlternatives: 'Alternatives plus tard',
	differentStops: 'Arrêts différents',
	rent: 'Louer',
	copyToClipboard: 'Copier dans le presse-papiers',
	rideThroughAllowed: 'Passage autorisé',
	rideThroughNotAllowed: 'Passage non autorisé',
	rideEndAllowed: 'Stationnement autorisé',
	rideEndNotAllowed: 'Stationnement uniquement aux stations',
	DEBUG_BUS_ROUTE: 'Itinéraire de bus (Debug)',
	DEBUG_RAILWAY_ROUTE: 'Itinéraire ferroviaire (Debug)',
	DEBUG_FERRY_ROUTE: 'Itinéraire de ferry (Debug)',
	colorMode: {
		none: 'Aucun',
		stops: 'Arrêts',
		rt: 'Trajets par temps réel',
		route: 'Trajets par ligne',
		mode: 'Trajets par mode'
	},
	routes: (n: number) => {
		switch (n) {
			case 0:
				return 'Aucun itinéraire';
			case 1:
				return '1 itinéraire';
			default:
				return `${n} itinéraires`;
		}
	}
};

export default translations;
